// extracted by mini-css-extract-plugin
module.exports = {"link":"Enlace_link__1I7en"};